export const LOADED = "filter/load";
export const FILTER_BY = "filter/filterBy";